import type { components } from '@/generated/internal-api/openapi-types';

export type ExportV1 = components['schemas']['ExportV1.schema'];
export type ExportApiId = components['schemas']['ExportApiId.schema'];

export const STATUS_LABEL: Record<ExportV1['status'], string> = {
  in_progress: 'In progress',
  completed: 'Completed',
  failed: 'Failed',
};
